'use es6';

export const metricToCamelCase = type => {
  const [first, ...rest] = type.split('_');
  return first.toLowerCase() + rest.map(word => word.slice(0, 1) + word.slice(1).toLowerCase()).join('');
};